export type CatalogueField = {
  name: string
  section: string
  requiredConfigurable: boolean
}

export type FieldSetting = {
  name: string
  writeable?: boolean
  required?: boolean
}

export enum PermissionFlag {
  WRITEABLE = "writeable",
  REQUIRED = "required",
}

export type ToggleOption = {
  value: boolean
  label: string
}

export type TourFieldPermissions = {
  tourId: string
  tourName: string
  tourCodes: string[]
  tourBrands: string[]
  fieldsLockedOnEveryDocument: string[]
  fieldsLockedOnSomeDocuments: string[]
  fieldsRequiredOnEveryDocument: string[]
  fieldsRequiredOnSomeDocuments: string[]
}

export type CurrentPermissionState = {
  value: boolean | undefined
  mixed: boolean
}

export type FieldSettingWithCurrentState = FieldSetting & {
  pickedSetting: FieldSetting
}

export type PendingFieldPermissionChange = {
  fieldName: string
  permissionFlag: PermissionFlag
  pickedPermissionValue: boolean
}
